import { SET_ACLS, SET_GROUPED_ACLS_BY_USER } from '@Actions/accessControlActions';
export const defaultState = {
    nonApprovalAcls: [],
    coexpensingAcls: [],
    groupedAclsByUser: null
};
export function accessControlReducer(state = defaultState, action) {
    switch (action.type) {
        case SET_ACLS: {
            return Object.assign(Object.assign({}, state), { nonApprovalAcls: action.payload.filter((acl) => acl.access_type === 'user_profile.non_approval'), coexpensingAcls: action.payload.filter((acl) => acl.access_type === 'linked_account.coexpensing') });
        }
        case SET_GROUPED_ACLS_BY_USER: {
            return Object.assign(Object.assign({}, state), { groupedAclsByUser: action.payload });
        }
        default:
            return state;
    }
}
